import React, {Component, ComponentType} from 'react';

import CookiesContext from './cookiesContext';

/**
 * HOC to pass cookies data to wrapped component
 */
// eslint-disable-next-line @typescript-eslint/naming-convention,require-jsdoc
export default function withCookies<PropsType>(ComposedComponent: ComponentType<PropsType>) {
    const name = ComposedComponent.displayName || ComposedComponent.name;

    // eslint-disable-next-line react/prefer-stateless-function
    return class extends Component<PropsType> {
        static displayName = `withCookies(${name})`;

        // eslint-disable-next-line require-jsdoc
        render() {
            return (
                <CookiesContext.Consumer>
                    {manager => <ComposedComponent cookies={manager.getAll()} {...this.props} />}
                </CookiesContext.Consumer>
            );
        }
    };
}
